import React, { useState, useEffect } from "react";
import { Skeleton } from "antd";
import Scrollspy from "react-scrollspy";
import { useLocation } from "react-router-dom";
import {
  UserOutlined,
  FolderOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
const ScrollSpy = (props) => {
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  useEffect(() => {
    console.log(props);
    if (query.get("jobPostingID")) {
      setCurrentPath(
        currentPath + "?jobPostingID=" + query.get("jobPostingID")
      );
    }
  }, []);

  return (
    <Skeleton loading={props.isLoading} active>
      <>
        {props && ["USA"].includes(props.countrycode) && (
          <Scrollspy
            currentClassName="isCurrent"
            className="scrollspy"
            rootEl=".scrollspy-container"
            items={[
              "personal-info",
              "documents",
              "jobs-info",
              "work-sched",
              "employment-info",
              "agreement-statement",
            ]}
          >
            <li>
              <a href={currentPath + "#personal-info"}>
                <UserOutlined className="inline-icon" /> Personal Information
              </a>
            </li>
            <li>
              <a href={currentPath + "#documents"}>
                <FolderOutlined className="inline-icon" /> Documents
              </a>
            </li>
            <li id="main-for-sub">
              <a href={currentPath + "#jobs-info"}>
                <IdcardOutlined className="inline-icon" /> Job Specific
                Information
              </a>
            </li>
            {!props.workSchedShow ?? (
              <li className="sub for-main-section">
                <a href={currentPath + "#work-sched"}>Work Schedule</a>
              </li>
            )}
            <li className="sub for-main-section">
              <a href={currentPath + "#employment-info"}>
                Employment Information
              </a>
            </li>
            <li className="sub for-main-section">
              <a href={currentPath + "#agreement-statement"}>
                Agreements and Statements
              </a>
            </li>
          </Scrollspy>
        )}
        {props &&
          ["CAN", "HKG", "PHL", "COL"].includes(props.countrycode) && (
            <Scrollspy
              currentClassName="isCurrent"
              className="scrollspy"
              rootEl=".scrollspy-container"
              items={[
                "personal-info",
                "documents",
                "jobs-info",
                "work-sched",
                "employ-verify",
                "apply-statement",
              ]}
            >
              <li>
                <a href={currentPath + "#personal-info"}>
                  <UserOutlined className="inline-icon" /> Personal Information
                </a>
              </li>
              <li>
                <a href={currentPath + "#documents"}>
                  <FolderOutlined className="inline-icon" /> Documents
                </a>
              </li>
              <li id="main-for-sub">
                <a href={currentPath + "#jobs-info"}>
                  <IdcardOutlined className="inline-icon" /> Job Specific
                  Information
                </a>
              </li>
              {/* <li className="sub for-main-section"><a href={currentPath + "#work-sched"}>Work Schedule</a></li> */}
              {!props.workSchedShow ?? (
                <li className="sub for-main-section">
                  <a href={currentPath + "#work-sched"}>Work Schedule</a>
                </li>
              )}
              <li className="sub for-main-section">
                <a href={currentPath + "#employ-verify"}>Employment Verify</a>
              </li>
              <li className="sub for-main-section">
                <a href={currentPath + "#apply-statement"}>
                  Applicant Statement
                </a>
              </li>
            </Scrollspy>
          )}
        {props && ["IND", "MEX", "POL", "EGY", "AUS"].includes(props.countrycode) && (
          <Scrollspy
            currentClassName="isCurrent"
            className="scrollspy"
            rootEl=".scrollspy-container"
            items={[
              "personal-info",
              "documents",
              "jobs-info",
              "work-sched",
              "apply-statement",
            ]}
          >
            <li>
              <a href={currentPath + "#personal-info"}>
                <UserOutlined className="inline-icon" /> Personal Information
              </a>
            </li>
            <li>
              <a href={currentPath + "#documents"}>
                <FolderOutlined className="inline-icon" /> Documents
              </a>
            </li>
            <li id="main-for-sub">
              <a href={currentPath + "#jobs-info"}>
                <IdcardOutlined className="inline-icon" /> Job Specific
                Information
              </a>
            </li>
            {/* <li className="sub for-main-section"><a href={currentPath + "#work-sched"}>Work Schedule</a></li> */}
            {!props.workSchedShow ?? (
              <li className="sub for-main-section">
                <a href={currentPath + "#work-sched"}>Work Schedule</a>
              </li>
            )}
            <li className="sub for-main-section">
              <a href={currentPath + "#apply-statement"}>Applicant Statement</a>
            </li>
          </Scrollspy>
        )}

        {props &&
          ["TTO"].includes(props.countrycode) && (
            <Scrollspy
              currentClassName="isCurrent"
              className="scrollspy"
              rootEl=".scrollspy-container"
              items={[
                "personal-info",
                "documents",
                "jobs-info",
                "work-sched",
                "employ-verify",
                "apply-statement",
              ]}
            >
              <li>
                <a href={currentPath + "#personal-info"}>
                  <UserOutlined className="inline-icon" /> Personal Information
                </a>
              </li>
              <li id="main-for-sub">
                <a href={currentPath + "#jobs-info"}>
                  <IdcardOutlined className="inline-icon" /> Job Specific
                  Information
                </a>
              </li>
              {/* <li className="sub for-main-section"><a href={currentPath + "#work-sched"}>Work Schedule</a></li> */}
              {!props.workSchedShow ?? (
                <li className="sub for-main-section">
                  <a href={currentPath + "#work-sched"}>Work Schedule</a>
                </li>
              )}
              <li className="sub for-main-section">
                <a href={currentPath + "#employ-verify"}>Employment Verify</a>
              </li>
              <li className="sub for-main-section">
                <a href={currentPath + "#apply-statement"}>
                  Applicant Statement
                </a>
              </li>
            </Scrollspy>
          )}

        {props && ["PAN"].includes(props.countrycode) && (
          <Scrollspy
            currentClassName="isCurrent"
            className="scrollspy"
            rootEl=".scrollspy-container"
            items={[
              "personal-info",
              "documents",
              "jobs-info",
              "work-sched",
              "apply-statement",
            ]}
          >
            <li>
              <a href={currentPath + "#personal-info"}>
                <UserOutlined className="inline-icon" /> Personal Information
              </a>
            </li>
            <li id="main-for-sub">
              <a href={currentPath + "#jobs-info"}>
                <IdcardOutlined className="inline-icon" /> Job Specific
                Information
              </a>
            </li>
            {/* <li className="sub for-main-section"><a href={currentPath + "#work-sched"}>Work Schedule</a></li> */}
            {!props.workSchedShow ?? (
              <li className="sub for-main-section">
                <a href={currentPath + "#work-sched"}>Work Schedule</a>
              </li>
            )}
            <li className="sub for-main-section">
              <a href={currentPath + "#apply-statement"}>Applicant Statement</a>
            </li>
          </Scrollspy>
        )}
      </>
    </Skeleton>
  );
};
export default ScrollSpy;
